import React from 'react';
const BankPage = () => <h1>Bancos</h1>;
export default BankPage;